import './TrainWithReach360Dialog.scss'

import Dialog from 'lib/components/Dialog/Dialog'
import ActionDialog from 'pages/Home/admin/ActionDialog/ActionDialog'
import React, { useRef } from 'react'
import { Trans, useTranslation } from 'react-i18next'

export interface TrainDialogProps {
  onRequestClose: ()=> void
  url: string
}

export default function TrainWithReach360Dialog({ onRequestClose, url }: TrainDialogProps) {
  const continueRef = useRef(null)
  const [t] = useTranslation()

  return (
    <Dialog
      className="alt-dialog-modal"
      focusTrap
      initialFocus={() => continueRef?.current}
      onRequestClose={onRequestClose}
      type="warning"
    >
      <Dialog.Header className="alt-dialog-header" onRequestClose={onRequestClose}>
        <Dialog.Title className="alt-dialog-header-title">
          {t('trainWithReach360.header')}
        </Dialog.Title>
      </Dialog.Header>
      <ActionDialog.Body className="alt-content">
        <strong className="alt-description">
          {t('trainWithReach360.body')}
        </strong>
      </ActionDialog.Body>
      <ActionDialog.Footer className="alt-dialog-footer">
        <a className="continue-button" href={url} onClick={onRequestClose} ref={continueRef} target="blank">
          <Trans i18nKey="trainWithReach360.buttons.continue" t={t}>
            <span className="visually-hidden-always" />
          </Trans>
        </a>
      </ActionDialog.Footer>
    </Dialog>
  )
}
